import { render, staticRenderFns } from "./group-set.vue?vue&type=template&id=ebb0d18c"
import script from "./group-set.vue?vue&type=script&lang=js"
export * from "./group-set.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports